import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { SalesInsightsActivityCalendarComponent } from './components/sales-insights-activity-calendar/sales-insights-activity-calendar.component';
import { SalesInsightsActivityListComponent } from './components/sales-insights-activity-list/sales-insights-activity-list.component';
import { SalesInsightsActivityTypesComponent } from './components/sales-insights-activity-types/sales-insights-activity-types.component';
import { SalesInsightsBarChartComponent } from './components/sales-insights-bar-chart/sales-insights-bar-chart.component';
import { SalesInsightsBookActivityComponent } from './components/sales-insights-book-activity/sales-insights-book-activity.component';
import { SalesInsightsCardComponent } from './components/sales-insights-card/sales-insights-card.component';
import { SalesInsightsCustomerHealthComponent } from './components/sales-insights-customer-health/sales-insights-customer-health.component';
import { SalesInsightsDashboardComponent } from './components/sales-insights-dashboard/sales-insights-dashboard.component';
import { SalesInsightsDonutComponent } from './components/sales-insights-donut/sales-insights-donut.component';
import { SalesInsightsFilterBarComponent } from './components/sales-insights-filter-bar/sales-insights-filter-bar.component';
import { SalesInsightsGoalProgressComponent } from './components/sales-insights-goal-progress/sales-insights-goal-progress.component';
import { SalesInsightsKpiComponent } from './components/sales-insights-kpi/sales-insights-kpi.component';
import { SalesInsightsLineChartComponent } from './components/sales-insights-line-chart/sales-insights-line-chart.component';
import { SalesInsightsOrderListComponent } from './components/sales-insights-order-list/sales-insights-order-list.component';
import { SalesInsightsProgressTableComponent } from './components/sales-insights-progress-table/sales-insights-progress-table.component';
import { SalesInsightsStatTilesComponent } from './components/sales-insights-stat-tiles/sales-insights-stat-tiles.component';
import { SalesInsightsListSearchComponent } from './components/sales-insights-list-search/sales-insights-list-search.component';
import { SalesInsightsTableComponent } from './components/sales-insights-table/sales-insights-table.component';
import { SalesInsightsTranslationsService } from './services/sales-insights-translations.service';

@NgModule({
  declarations: [
    SalesInsightsDashboardComponent,
    SalesInsightsFilterBarComponent,
    SalesInsightsCardComponent,
    SalesInsightsKpiComponent,
    SalesInsightsBarChartComponent,
    SalesInsightsLineChartComponent,
    SalesInsightsDonutComponent,
    SalesInsightsTableComponent,
    SalesInsightsStatTilesComponent,
    SalesInsightsListSearchComponent,
    SalesInsightsCustomerHealthComponent,
    SalesInsightsGoalProgressComponent,
    SalesInsightsActivityListComponent,
    SalesInsightsActivityCalendarComponent,
    SalesInsightsProgressTableComponent,
    SalesInsightsOrderListComponent,
    SalesInsightsBookActivityComponent,
    SalesInsightsActivityTypesComponent
  ],
  imports: [CommonModule, SharedModule],
  exports: [SalesInsightsDashboardComponent, SalesInsightsCardComponent, SalesInsightsBookActivityComponent],
  providers: [SalesInsightsTranslationsService]
})
export class SalesInsightsModule {
  constructor() {
    inject(SalesInsightsTranslationsService).register();
  }
}
